import {
  Box,
  IconButton,
  List,
  ListItem,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import Coin from "./Coin";
import { MoreOne } from "assets/Icon";
import NumberFormats from "components/NumberFormats";

function CoinCardWithColumn({ coin, headers, onAction }) {
  const theme = useTheme();

  return (
    <BoxWrap>
      <BoxHeaderWrapper>
        <MenuButton onClick={() => onAction(coin)} size="small" color="text">
          <MoreOne color={theme.palette.text.secondary} />
        </MenuButton>

        <BoxTop>
          <Coin coin={coin} />
        </BoxTop>
      </BoxHeaderWrapper>

      <BoxMain>
        <List>
          {headers?.map((head) => (
            <ListItem>
              <Typography variant="h6">
                {head.title}:
                <Typography
                  variant="h6"
                  component="span"
                  fontWeight={head.bold ? 600 : 400}
                  color={head.bold ? "text.main" : ""}
                  paddingLeft={0.5}
                >
                  <NumberFormats value={coin[head?.key]} />
                </Typography>
              </Typography>
              <Typography
                variant="h6"
                component="span"
                color="secondary.main"
                paddingLeft={0.5}
              >
                {coin[head?.key + "Comment"]}
              </Typography>
            </ListItem>
          ))}
        </List>
      </BoxMain>
    </BoxWrap>
  );
}

const BoxWrap = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  border: `1px solid ${theme.palette.modules.border}`,
  padding: theme.spacing(2),
  minHeight: "100%",
  position: "relative",
  borderRadius: "10px",
}));

const MenuButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  transform: "translateY(calc(-50% - 10px))",
  right: 0,
}));

const BoxHeaderWrapper = styled(Box)(() => ({
  position: "relative",
}));

const BoxTop = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  paddingBottom: theme.spacing(1.25),
}));

const BoxMain = styled(Box)(({ theme }) => ({
  li: {
    color: theme.palette.text.secondary,
    flexDirection: "column",
    alignItems: "baseline",
  },
}));

export default CoinCardWithColumn;
